import { faCheck, faClipboard } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

interface ClipboardIconProps {
	content: string;
	textColorClass?: string;
}

const copyOperation = (text: string) => {
	navigator.clipboard.writeText(text);
};

export const ClipboardIcon = ({ content, textColorClass = 'text-white' }: ClipboardIconProps) => {
	const [copiedURL, setCopiedURL] = useState<boolean>(false);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (copiedURL) setCopiedURL(false);
		}, 1000);

		return () => clearTimeout(timeout);
	}, [copiedURL]);

	return (
		<FontAwesomeIcon
			icon={copiedURL ? faCheck : faClipboard}
			className={clsx('cursor-pointer text-white', textColorClass)}
			onClick={() => {
				copyOperation(content);
				setCopiedURL(true);
			}}
			size={copiedURL ? 'xs' : 'sm'}
		/>
	);
};
